const LoadingSpinner = ({ size = 'md', className = '', fullScreen = false }: { size?: 'sm' | 'md' | 'lg', className?: string, fullScreen?: boolean }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  }

  const containerClasses = fullScreen 
    ? `min-h-screen flex items-center justify-center bg-gray-50 ${className}`
    : `flex items-center justify-center ${className}`

  return (
    <div className={containerClasses}>
      <div className="text-center">
        <div className={`animate-spin rounded-full border-b-2 border-blue-600 mx-auto ${sizeClasses[size]}`}></div>
        {fullScreen && <p className="mt-4 text-gray-600">Carregando...</p>}
      </div>
    </div>
  )
}

export default LoadingSpinner